'use client';

import { useState } from 'react';
import { Book, Title } from 'types';
import { truncate } from 'sdk';
import styles from '@/styles/components/product/product-details.module.scss';
import Spacer from '@/components/spacer';
import { Box } from '../layout/box';
import Text from '../typography/text';
import AccordionWrapper from '../accordion/wrapper';
import AccordionHeaderWrapper from '../accordion/header-wrapper';
import AccordionContentWrapper from '../accordion/content-wrapper';
import Link from 'next/link';



export default function ProductDescription({ book, title }: { book?: Book; title?: Title }) {
  const [isTruncated, setIsTruncated] = useState<boolean>(true);

  function renderBookTitle() {
    if (!book?.title) {
      return null;
    }
    return <h3>{book.subtitle ? `${book.title}: ${book.subtitle}` : book.title}</h3>;
  }

  function shouldRenderIsbn() {
    if (book) {
      return !!book.isbn;
    }
  }

  function renderIsbn() {
    if (book) {
      return  `${book.isbn}`;
    }
  }

  function shouldRenderSummary() {
    return !!title?.summary || !!book?.summary;
  }

  function shouldRender() {
    return shouldRenderIsbn() || title?.summary || book?.summary;
  }

  function handlePress() {
    setIsTruncated(!isTruncated);
  }

  if (!shouldRender()) return null;

  const truncatedText = truncate(title?.summary || book?.summary, 200);
  const fullText = title?.summary || book?.summary;

  return (
    <AccordionWrapper defaultOpen>
      <AccordionHeaderWrapper>
        <Box>
          <Text size='large' font='bold'>
            Overview
          </Text>
        </Box>
      </AccordionHeaderWrapper>
      <AccordionContentWrapper>
        <div className={styles['product-details']}>
          <div className={styles['product-details']}>
            {renderBookTitle()}
            {shouldRenderIsbn() && (
              <div>
                <h3>
                  {`ISBN: `}
                  <Link href={`/data/isbn/${book.isbn}`} target="_blank">
                    <span style={{ cursor: 'pointer', transition: 'color 0.3s' }} onMouseEnter={(e) => e.currentTarget.style.color = '#3b61eb'} onMouseLeave={(e) => e.currentTarget.style.color = ''}>
                      {renderIsbn()}
                    </span>
                  </Link>
                </h3>
                <Spacer size='small' />
              </div>
            )}
            <h3 className={styles['subcategory']}>Publisher Description</h3>
            {shouldRenderSummary() && <p>{isTruncated ? truncatedText : title?.summary || book?.summary}</p>}
            {truncatedText.trim() !== fullText?.trim() &&
              (isTruncated ? (
                <div className={styles['click-text']} onClick={handlePress}>
                  <p>Read more</p>
                </div>
              ) : (
                <div className={styles['click-text']} onClick={handlePress}>
                  <p>Read less</p>
                </div>
              ))}
          </div>
        </div>
      </AccordionContentWrapper>
    </AccordionWrapper>
  );
}
